export default __webpack_public_path__ + "static/media/photo--sm--rene-1.8396f7ef.jpg";